import { createAsyncThunk } from "@reduxjs/toolkit"
import { AppThunkAPIType } from "../../app/appTypes"
import { deleteWithAuth, getWithAuth, postWithAuth } from "../../http"

export type NotificationType
    = "MENTION"
    | "COMMENT"

export interface UserNotification {
    id: string
    message: string
    link: string
    isRead: boolean
    createdAt: string
    notificationType: NotificationType
}

export const loadUserNotifications = createAsyncThunk<UserNotification[], void, AppThunkAPIType>("/user-notifications/load",
    async (_, { dispatch, rejectWithValue }) => {
        const result = await dispatch(getWithAuth({ url: `api/user-notifications` }))
        const { payload } = result
        if (getWithAuth.fulfilled.match(result)) {
            return payload as UserNotification[]
        } else {
            return rejectWithValue(payload ?? { kind: 'unknown' })
        }
    })


export const markUserNotificationAsRead = createAsyncThunk<string, string, AppThunkAPIType>(
    "user-notifications/mark-as-read",
    async (id, { dispatch, rejectWithValue }) => {
        const result = await dispatch(
            postWithAuth({ url: `api/user-notifications/${id}/mark-as-read`, payload: {} })
        );

        if (postWithAuth.fulfilled.match(result)) {
            return id;
        } else {
            return rejectWithValue(result.payload ?? { kind: "unknown" });
        }
    }
);

export const markUserNotificationsAsReadByIds = createAsyncThunk<void, string[], AppThunkAPIType>(
    "user-notifications/mark-all-as-read",
    async (ids, { dispatch, rejectWithValue }) => {
        const result = await dispatch(
            postWithAuth({ url: `api/user-notifications/mark-all-as-read`, payload: { ids } })
        );

        if (postWithAuth.fulfilled.match(result)) {
            return;
        } else {
            return rejectWithValue(result.payload ?? { kind: "unknown" });
        }
    }
);

export const deleteUserNotificationsByIds = createAsyncThunk<void, string[], AppThunkAPIType>(
    "user-notifications/delete-all",
    async (ids, { dispatch, rejectWithValue }) => {
        const result = await dispatch(
            postWithAuth({ url: `api/user-notifications/delete-all`, payload: { ids } })
        );

        if (postWithAuth.fulfilled.match(result)) {
            return;
        } else {
            return rejectWithValue(result.payload ?? { kind: "unknown" });
        }
    }
);


export const deleteUserNotification = createAsyncThunk<string, string, AppThunkAPIType>(
    "user-notifications/delete",
    async (id, { dispatch, rejectWithValue }) => {
        const result = await dispatch(
            deleteWithAuth({ url: `api/user-notifications/${id}` })
        );

        if (deleteWithAuth.fulfilled.match(result)) {
            return id;
        } else {
            return rejectWithValue(result.payload ?? { kind: "unknown" });
        }
    }
);



